export const isLoading = (state) => state.auth.isLoading
export const user = (state) => state.auth.user
export const error = (state) => state.auth.error
export const isSuccessVerified = (state) => state.auth.isSuccessVerified
export const resetPasswordError = (state) => state.auth.resetPasswordError
export const isSuccessSentCode = (state) => state.auth.isSuccessSentCode
